export default "__VITE_ASSET__Brad_R2W__"